export default "__VITE_ASSET__ee0630b9__"